import { CanvasRenderingTarget2D } from 'fancy-canvas'
import {
    IChartApi,
    ISeriesApi,
    ISeriesPrimitive,
    IPrimitivePaneRenderer,
    IPrimitivePaneView,
    SeriesOptionsMap,
    SeriesType,
    Time
} from 'lightweight-charts'

class ScrollDetectRenderer implements IPrimitivePaneRenderer {
    _options: ScrollDetectOptions

    constructor(options: ScrollDetectOptions) {
        this._options = options
    }

    draw(target: CanvasRenderingTarget2D) {
        this._options.onScroll()
    }
}

class ScrollDetectPaneView implements IPrimitivePaneView {
    _source: ScrollDetector
    _options: ScrollDetectOptions
    _renderer: ScrollDetectRenderer

    constructor(source: ScrollDetector, options: ScrollDetectOptions) {
        this._source = source
        this._options = options
        this._renderer = new ScrollDetectRenderer(this._options)
    }

    renderer() {
        return this._renderer
    }
}

export interface ScrollDetectOptions {
    onScroll: () => void
}

const defaultOptions: ScrollDetectOptions = {
    onScroll: () => {
    }
}

export class ScrollDetector implements ISeriesPrimitive<Time> {
    _chart: IChartApi
    _series: ISeriesApi<keyof SeriesOptionsMap>
    _paneViews: ScrollDetectPaneView[]

    constructor(
        chart: IChartApi,
        series: ISeriesApi<SeriesType>,
        options?: Partial<ScrollDetectOptions>
    ) {
        const scrollDetectOptions: ScrollDetectOptions = {
            ...defaultOptions,
            ...options
        }
        this._chart = chart
        this._series = series
        this._paneViews = [new ScrollDetectPaneView(this, scrollDetectOptions)]
    }

    updateAllViews() {

    }

    paneViews() {
        return this._paneViews
    }
}
